<!-- Toggle Button -->
<app-button
  variant="sidenav-toggle"
  (click)="onToggleSidebar()"
  [class.toggle-collapsed]="effectiveCollapsedState"
  [class.toggle-expanded]="!effectiveCollapsedState">
</app-button>

<div class="if-sidenav-cabinet" [class.collapsed]="effectiveCollapsedState" [class.mobile-open]="isOpen()">
  <!-- Mobile Overlay -->
  @if (isOpen()) {
    <div class="mobile-overlay" (click)="onCloseSidebar()"></div>
  }

  <!-- Sidebar Content -->
  <div
    class="sidenav-content"
    [@slideInLeftOnEnter]="!effectiveCollapsedState"
    [@slideOutLeftOnLeave]="effectiveCollapsedState">
    <ng-content></ng-content>
  </div>
</div>
